import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Typography } from "@mui/material";
import type { ReviewMomentReference, TimeControl } from "@chessla/shared";

export interface ChatReviewContext {
  reference: ReviewMomentReference;
  cohort: TimeControl;
  eyebrow: string;
  summary: string;
  question: string;
  prompts: readonly { label: string; prompt: string }[];
}

export const ChatContextStrip = ({
  context,
  onDismiss,
  onPrompt,
}: {
  context: ChatReviewContext;
  onDismiss: () => void;
  onPrompt: (prompt: string) => void;
}) => (
  <Box
    component="aside"
    aria-label="Game Review context"
    sx={{
      maxWidth: 760,
      mx: "auto",
      mb: 2.5,
      p: { xs: 1.25, sm: 1.5 },
      border: "1px solid",
      borderColor: "rgba(240,236,226,.32)",
      borderLeft: "3px solid",
      borderLeftColor: "secondary.main",
      bgcolor: "rgba(240,236,226,.025)",
    }}
  >
    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 44px", alignItems: "start", gap: 1 }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ color: "secondary.main", fontSize: ".58rem", fontWeight: 900, letterSpacing: ".1em" }}>
          {context.eyebrow}
        </Typography>
        <Typography
          sx={{ mt: 0.35, fontSize: ".68rem", fontWeight: 900, letterSpacing: ".045em", overflowWrap: "anywhere" }}
        >
          {context.summary}
        </Typography>
      </Box>
      <IconButton
        aria-label="Dismiss review context"
        onClick={onDismiss}
        size="small"
        sx={{ width: 44, height: 44, borderRadius: 0 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    <Typography sx={{ mt: 1, color: "text.secondary", fontSize: ".78rem", lineHeight: 1.5 }}>
      {context.question}
    </Typography>
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1.25 }}>
      {context.prompts.map((item) => (
        <Button
          key={item.label}
          variant="outlined"
          size="small"
          onClick={() => onPrompt(item.prompt)}
          sx={{ minHeight: 44, borderRadius: 0, fontSize: ".59rem" }}
        >
          {item.label}
        </Button>
      ))}
    </Box>
  </Box>
);
